import { apiRequest, toQueryString } from './apiRequest';

type NotificationsListParams = {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
  types?: string[];
};

export const notificationsAPI = {
  getAll: async (params: NotificationsListParams = {}) => {
    const query: Record<string, string | number | boolean> = {};
    if (params.limit != null) query.limit = params.limit;
    if (params.offset != null) query.offset = params.offset;
    if (params.unreadOnly) query.unreadOnly = 'true';
    if (params.types?.length) query.types = params.types.join(',');
    return await apiRequest<any>(`/api/notifications${toQueryString(query)}`, {
      method: 'GET',
    });
  },
  getUnreadCount: async () => {
    return await apiRequest<any>('/api/notifications/unread-count', { method: 'GET' });
  },
  markRead: async (id) => {
    return await apiRequest<any>(`/api/notifications/${id}/read`, {
      method: 'PATCH',
    });
  },
  markAllRead: async () => {
    return await apiRequest<any>('/api/notifications/mark-all-read', {
      method: 'POST',
    });
  },
};
